// extracted by mini-css-extract-plugin
module.exports = {"root":"QuizQuestionAnswerInput_root__3VEMK","fieldContainer":"QuizQuestionAnswerInput_fieldContainer__1mkEk"};